import { BaseWidget } from ".";
import { TextAreaControl } from "../controls/TextAreaControl";
import SubjectIcon from '@mui/icons-material/Subject';
import { ColorControl } from "../controls/ColorControl";
import { FontControl } from "../controls/grouped/FontControl";
import DOMPurify from 'dompurify';

export class ParagraphWidget extends BaseWidget {
    
    getName() {
        return 'Paragraaf';
    }

    getIcon() {
        return <SubjectIcon />;
    }

    getControls() {
        return {
            'font': new FontControl({
                label: 'Lettertype',
                description: 'Instellingen voor het lettertype van de kop',
                defaultValue: {
                    fontFamily: 'Poppins',
                },
            }),
            'text': new TextAreaControl({
                label: 'Tekst',
                description: 'De tekst van de paragraaf',
                defaultValue: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                options: {
                    rows: 4,
                    cols: 50
                }
            }),
            'color': new ColorControl({
                label: 'Kleur',
                description: 'Kleur van de kop',
                defaultValue: '#000000',
            })
        };
    }

    /**
     * @param {{
     *     [K in keyof ReturnType<typeof this.getControls>]: ReturnType<typeof this.getControls>[K]['defaultValue']
     * }} props
     * @returns {React.ReactNode}
     */
    render(props) {
        /* 'p' must stay allowed: TinyMCE wraps every paragraph (Enter key) in
           its own <p> — stripping them collapses multi-paragraph text into one
           running line. The wrapper below is a <div> because <p> can't nest. */
        const sanitizedText = DOMPurify.sanitize(props.text, {
            ALLOWED_TAGS: ['p', 'b', 'i', 'em', 'strong', 'a', 'ol', 'ul', 'li', 'br'],
            ALLOWED_ATTR: ['href', 'target', 'rel']
        });

        return <div className="paragraph-widget"
            style={{
                // @ts-ignore
                textAlign: props.font.alignment,
                color: props.color,
                fontSize: props.font.fontSize ? this.getCssValue(props.font.fontSize) : undefined,
                fontFamily: props.font?.fontFamily,
                fontStyle: props.font?.fontStyle,
                fontWeight: props.font?.fontWeight,
                textDecoration: props.font?.textDecoration
            }}
            dangerouslySetInnerHTML={{ __html: sanitizedText }}
        />;
    }
}
